import { trackLead } from './leads';

// All updates here to MOVE_DATA.adobeDTM/leadAdobeDTM/modal here are temporary until migration is done.

// Locations where we need to pass the click tracking tag to the submit btn of the modal itself.

const modalSubmitLocations = [
  '#request-private-showing',
  '#gallery_request_more_details',
  '#secondary_request_more_details_mobile_sticky',
  '#homes-around-card'
];

export const fireLeadTracking = function($widget, pd, data, ldpPropertyDetails){

  if (!MOVE_DATA.leadAdobeDTM) {
    MOVE_DATA.leadAdobeDTM = {};
  }
  var leadData = {};
  const leadPlacement = $widget.find(".submit").attr("data-omtrack");

  if (pd.property_type === 'not_for_sale') {
    leadData = prepareSellerLeadTracking(data.lead.id, $widget);
  } else {
    leadData = prepareLeadTracking($widget, data.lead.id, data.lead_value, data.initial_lead_value, pd);
  }

  //setting leadPlacement to adobeDTM object in addition to leadData for now. This is temporary until tracking migration is done.
  if (isValidModalSubmitLocation($widget.selector)) {
    MOVE_DATA.leadAdobeDTM.leadPlacement = MOVE_DATA.adobeDTM.leadCtaClickSource;
    leadData.placementData = MOVE_DATA.adobeDTM.leadCtaClickSource;
  } else if (leadPlacement) {
    MOVE_DATA.leadAdobeDTM.leadPlacement = leadPlacement;
    leadData.placementData = leadPlacement;
  }
  //Updates the leadAdobeDTM object. This will be removed when tracking migration is complete.
  MOVE.Helper.updateOmnitureLeadJson(leadData);

  const additionalData = {productType: MOVE_DATA.adobeDTM.productType, rentalDataSource: (MOVE_DATA.adobeDTM.dataSourceType || 'unknown')};
  const trackingData = Object.assign({}, ldpPropertyDetails || pd, leadData, additionalData );

  if (pd.is_nearby_home_card) {
    //nearby property cards need to submit lead info about the property itself instead of the LDP property
    Object.assign(trackingData, pd);
  }

  //LGWEB-834: Image CTR
  MOVE_DATA.leadAdobeDTM.imageSwapped = MOVE_DATA.qv_imgctr_swapped;
  //END

  trackLead(trackingData);
};

const isValidModalSubmitLocation = function(selector) {
  var isValid = false;
  if (MOVE_DATA.adobeDTM.leadCtaClickSource) {
    modalSubmitLocations.forEach(function(id){
      if (selector.includes(id)){
        isValid = true;
      }
    })
  }
  return isValid;
}

const prepareSellerLeadTracking = function(guid, $widget){
  // Prepare lead tracking object with the guid returned from LCS
  var agentSelectionsCt = $widget.find('.js-seller-agent:checked').length;
  var selectedSellerAgents = $widget.find('.js-seller-agent:checked')
                                      .closest('.seller-enabled-lead-form');
  var leadJson =  {
          leadGuid:               guid,
          selectionsCt:           agentSelectionsCt,
          listing_advertiser_ids: mapDataAttrForSellerLead(selectedSellerAgents, 'data-advertiserID'),
          selAgentPosition:       mapDataAttrForSellerLead(selectedSellerAgents, 'data-selPosition'),
          roleType:               MOVE_DATA.adobeDTM.roleType,
          paidType:               MOVE_DATA.adobeDTM.roleType.length ? 'paid' : 'courtesy'
         };
  leadJson = $.extend(leadJson, addABTestAttributes($widget));
  return leadJson;
};

const prepareLeadTracking = function($widget, leadGuid, leadValue, initialLeadValue, pd) {
  var moveInDate = $widget.find("input[name='leads_form_data[move_in_date]']").val() || '';
  var leadAdditions =  moveInDate !== '' ? 'move' : '';
  var leadCreditScore = pd.creditScore;
  leadAdditions =  leadAdditions || pd.isMilitaryChecked ? 'military' : 'rcm' ;

  if($("#primary_lead_register").prop('checked')) {
    leadAdditions =  leadAdditions === "" ? "marketing" : leadAdditions + ",marketing";
  }
  return ({ leadGuid,
            moveInDate,
            leadAdditions,
            leadCreditScore,
            leadValue,
            initialLeadValue,
          });
};

const mapDataAttrForSellerLead = function(selectedSellerAgents, dataAttr){
  return selectedSellerAgents.map(function(){
                                  return $(this).attr(dataAttr);
                                }).get().join();
};

// Add additional attributes related to A/B test for NFS lead form
const addABTestAttributes = function($widget){
  var $sellDateSelectBox = $widget.find('.js-sell-date');
  var $homeOwnerCheckBox = $widget.find('.js-home-owner-option input:radio:checked');
  var leadJson = {};
  if($sellDateSelectBox.find('option').length === 7 || $homeOwnerCheckBox.length > 0){
    // Variation 1 -- Add not home owner option to dropdown
    if($sellDateSelectBox.find('option').length === 7){
      leadJson.lookingToSell = $sellDateSelectBox.val();
      leadJson.homeOwner     = $sellDateSelectBox.val() !== 'I am not the Homeowner';
    } else { // Variation 2 -- Add radio button for home owner
      var isHomeOwner = $homeOwnerCheckBox.val() === 'home-owner';
      leadJson.lookingToSell = isHomeOwner ? $sellDateSelectBox.val() : '';
      leadJson.homeOwner     = isHomeOwner;
    }
  }
  // for control
  else {
    leadJson.lookingToSell = $sellDateSelectBox.val();
    leadJson.homeOwner     = 'unknown';
  }
  return leadJson;
};



// WEBPACK FOOTER //
// ./shared_critical/tracking/shared/common_leads.js